import Base from './base';

const CLASS_HIDDEN = 'is-hidden-tab-content';
const CLASS_ACTIVE = 'is-active';

class Tabs extends Base {
	constructor(el) {
		super(el);

		this.on('click');

		this.start();
	}

	start() {
		const { hash } = window.location;

		if (!hash) {
			return;
		}

		this.setActiveTab(hash);
	}

	onClick(e) {
		const { target } = e;
		const isTab = target.classList.contains('js-tab-link');

		if (isTab) {
			// prevent scrolling: content will be underneath header
			e.preventDefault();

			this.toggleTab(target);
		}
	}

	setActiveTab(hash) {
		const tab = this.query(`.js-tab-link[href="${hash}"]`);

		if (!tab) {
			return;
		}

		this.toggleTab(tab);
	}

	toggleTab(tab) {
		// `tab.href` returns absolute URL
		const panelId = tab.getAttribute('href');
		const panel = this.query(panelId, document.body);

		this.resetActiveTab();
		this.disableActivePanel(panel);

		tab.classList.add(CLASS_ACTIVE);
		panel.classList.remove(CLASS_HIDDEN);

		// update the hash without scrolling
		history.pushState({}, '', panelId);
	}

	resetActiveTab() {
		const activeTab = this.query(`.${CLASS_ACTIVE}`);

		if (activeTab) {
			activeTab.classList.remove(CLASS_ACTIVE);
		}
	}

	disableActivePanel(panel) {
		const parent = panel.parentElement;
		const activePanel = this.query(`.js-tabs-panel:not(.${CLASS_HIDDEN})`, parent);

		if (activePanel) {
			activePanel.classList.add(CLASS_HIDDEN);
			this.deactivatePanel(activePanel);
		}
	}

	deactivatePanel(panel) {
		const youtubeIframe = this.query('.js-youtube-video', panel);

		if (youtubeIframe) {
			youtubeIframe.contentWindow.postMessage('{"event": "command", "func":"pauseVideo", "args": ""}', 'https://www.youtube-nocookie.com');
		}
	}
}

export default Tabs;
